import Inputmask from 'inputmask';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import Vue from 'vue';
import App from './App.vue';
import router from './router';

window.slugify = require('slugify');
window.axios = require('axios');


Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.component('cookies-consent', require('./components/CookiesConsent.vue').default);

new Vue({
    render: (h) => h(App),
    router,
    validations: {},
}).$mount('#app');
